import React from 'react';
import ReactDOM from 'react-dom';
import CustomersJobsTable from '../customers-jobs-table.jsx';
if (document.getElementById('react-component-g4-logistics-portal-view-customer-with-all-jobs')) {
  let customerId = document.getElementById(
    'react-component-g4-logistics-portal-view-customer-with-all-jobs'
  ).getAttribute('data-customer-id');
  ReactDOM.render(
    <CustomersJobsTable
      url = {"/api/v1/portal/customers/view/"+customerId+'/all-jobs'}
      message_if_none = 'Customer not found or available for viewing.'
    />,
    document.getElementById('react-component-g4-logistics-portal-view-customer-with-all-jobs')
  );
}
